import { Module } from 'framework/core';

import { CartAPI } from './cart.api';
import { PlatformModule } from '../platform/platform.module';

@Module({
  imports: [PlatformModule],
  providers: [CartAPI],
})
export class CartModule {}
